import * as React from 'react';
import CampfireButton from './CampfireButton';
import { ActionButton } from './ActionButtons';
import RAP, { AdditionalDetails } from './RAP';
import PinnedContent from './PinnedContent';
import '../css/package-card-rap.sass';
import HtmlContent from './HtmlContent';
import formatter from '../utils/formatter-util';
import SectionMessage, { SectionMessageType } from './SectionMessage';

interface PackageCardRAPProps {
  name: string;
  primaryText: string;
  secondaryText?: string;
  theme?: 'night' | 'day';
  priceValue: number;
  setRef?: any;
  disclaimerText?: React.ReactNode;
  rapButtonLabel?: string;
  children?: React.ReactNode;
  button?: ActionButton;
  additionalDetails?: AdditionalDetails;
  summaryText?: string;
  elementRefToPositionRAP?: string;
  messages?: SectionMessageType[];
  scrollRAPStopId?: string;
  scrollRAPTriggerId?: string;
  enableOnMobile?: boolean;
  fixPositionOnScroll?: boolean;
  logoUrl?: string;
  optionalLinkWithText?: React.ReactNode;
}

interface PackageCardRAPState {
  toggleRAP: boolean;
}

export default function PackageCardRAP(props: PackageCardRAPProps) {
  const [state, setState] = React.useState<PackageCardRAPState>({
    toggleRAP: false
  });
  const {
    theme = 'day',
    rapButtonLabel = 'Edit Package',
    elementRefToPositionRAP = 'packageCardRAP',
    enableOnMobile = false,
    fixPositionOnScroll = true
  } = props;

  const displayBtn: boolean = !(props.button && props.button.label === '');

  return (
    <>
      <div className={`package-card-rap ${theme}`} id="packageCardRAP">
        {!state.toggleRAP && (
          <PinnedContent
            theme={theme}
            value={formatter({
              type: 'number',
              format: 'amount',
              value: props.priceValue.toString()
            })}
            label={props.name}
            rapButtonLabel={rapButtonLabel}
            onRAPBtnClick={() => {
              setState({ ...state, toggleRAP: true });
            }}
            disableBtn={
              !enableOnMobile && props.button && props.button.disabled
            }
          />
        )}
        <RAP
          theme={theme}
          elementRefToPositionRAP={elementRefToPositionRAP}
          additionalDetails={props.additionalDetails}
          toggleRAP={state.toggleRAP}
          onRAPPopupClose={() => {
            setState({ ...state, toggleRAP: false });
          }}
          pinnedPosition="LOAD"
          fixPositionOnScroll={fixPositionOnScroll}
        >
          <div className="contents">
            {props.logoUrl && (
              <>
                <img className="pkg-img" alt={props.name} src={props.logoUrl} />
                <div className="pkg-divider" />
              </>
            )}
            <div className="name">{props.name}</div>
            <div className="primary-text">
              <HtmlContent html={props.primaryText} />
            </div>
            {props.secondaryText && (
              <div className="secondary-text">
                <HtmlContent html={props.secondaryText} />
              </div>
            )}
            <div className="summary-text">{props.summaryText}</div>
            {props.children}
            {displayBtn && props.button && (
              <div
                className="alignBtn"
                {...(props.optionalLinkWithText && {
                  style: { paddingBottom: '16px' }
                })}
              >
                <CampfireButton
                  theme={theme}
                  name="packageCardRAPBtn"
                  id="packageCardRAPBtn"
                  label={props.button.label}
                  color="water"
                  smol
                  onClick={props.button.onClick}
                  frosty={
                    !props.button.type || props.button.type === 'secondary'
                  }
                  ghost={
                    !props.button.type || props.button.type === 'secondary'
                  }
                  disabled={props.button.disabled}
                />
              </div>
            )}
            {props.optionalLinkWithText && (
              <div className="link-with-text">{props.optionalLinkWithText}</div>
            )}

            {props.messages && props.messages.length > 0 && (
              <div className="alignSectionMsg">
                <SectionMessage messages={props.messages} />
              </div>
            )}

            <div className="disclaimer">{props.disclaimerText}</div>
          </div>
        </RAP>
      </div>
    </>
  );
}
